module.exports = __webpack_public_path__ + "img/e432492.png";